import { ReceiptPdfModel } from '../../domain/receipt/receipt.model';
import { Observable } from 'rxjs';

export abstract class ReceiptPdfRepository {
  abstract getPdf(id: number): Observable<ReceiptPdfModel>;
  abstract getPdfExtract(nroMovimento: number): Observable<ReceiptPdfModel>;
}
